



























import { defineComponent, onMounted } from '@vue/composition-api';
import Idea from '@tt4b/ttam-assets/src/svgs/idea.svg';
import Done from '@tt4b/ttam-assets/src/svgs/done.svg';
const name = 'ttam-creative-carousel-promote-tip';
export default defineComponent({
  name,
  components: {
    Idea,
    Done,
  },
  props: {
    isAddingCreative: {
      type: Boolean,
      default: false,
    },
    isCarouselCreated: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    function onClose() {
      emit('close');
    }

    function onApply() {
      emit('apply');
    }
    onMounted(() => {
      emit('reset');
    });

    return {
      onClose,
      onApply,
      name,
    };
  },
});
